// File: src/services/pps/purposesClient.js
// Brokered Purposes client → hits your svc-broker at /svc/purposes/* (same-origin)

import axios from 'axios'
import vueCookie from 'vue-cookie'
import { SVC_PREFIX } from '@/config'

// Base path (path-only, same-origin, no real host exposed)
const BASE = `${SVC_PREFIX.replace(/\/+$/, '')}/pps`

// Remove null/undefined/'' so the query stays clean
const stripNil = obj => {
  const out = {}
  if (!obj) return out
  for (const k of Object.keys(obj)) {
    const v = obj[k]
    if (v !== undefined && v !== null && v !== '') out[k] = v
  }
  return out
}

// Single axios instance; JWT forwarded via Authorization header
const http = axios.create({
  baseURL: BASE,
  withCredentials: false,
  timeout: 15000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json; charset=utf-8',
  },
})

// Attach JWT if present (cookie names per your auth flow)
http.interceptors.request.use(cfg => {
  const tok = vueCookie.get('accessToken') || vueCookie.get('access_token')
  if (tok) cfg.headers.Authorization = `Bearer ${tok}`
  return cfg
})

// Bubble up status/body on errors for nicer logs upstream
http.interceptors.response.use(
  r => r,
  err => {
    err.__details = { status: err?.response?.status, data: err?.response?.data }
    return Promise.reject(err)
  },
)

// ---- Public endpoints ----

// GET /point-types?{ lang, sort, order }
export const listPointTypes = (params = {}) => http.get('/point-types', { params: stripNil(params) }).then(r => r.data)

// POST /purposes/match   (JSON body)
export const matchPurposes = payload => http.post('/purposes/match', payload).then(r => r.data)

// GET /purposes?{ lang, point_type_ids, limit, order, q }
export const listPurposes = (params = {}) => http.get('/purposes', { params: stripNil(params) }).then(r => r.data)

// GET /stats
export const stats = () => http.get('/stats').then(r => r.data)

// ---- Protected (handled server-side by broker; no API key in browser) ----

// POST /purposes/ingest
export const ingest = () => http.post('/purposes/ingest').then(r => r.data)

export default {
  listPointTypes, matchPurposes, listPurposes, stats, ingest,
}
